import { useQuery } from "@tanstack/react-query";
import api, { formatApiErrorDetail } from "@/lib/api";

export function errText(error) {
  if (!error) return null;
  return formatApiErrorDetail(error?.response?.data?.detail ?? error.message);
}

/**
 * Bridges our axios client to react-query so components stop hand-rolling fetch effects:
 * caching, request de-duplication and cancellation all come from the library.
 */
export function useApiQuery(queryKey, url, { params, enabled = true, ...options } = {}) {
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => (await api.get(url, { params, signal })).data,
    enabled,
    ...options,
  });
  return {
    data: query.data ?? null,
    loading: query.isLoading,
    refreshing: query.isFetching && !query.isLoading,
    err: errText(query.error),
    refetch: query.refetch,
  };
}
